import React from 'react'

const About = () => {
  return (
    <div>
      ABout
    </div>
  )
}

export default About
